import React, { useState } from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import ScrollToTopButton from '../components/ScrollToTopButton';
import './Contact/contact.css';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Replace with your EmailJS keys
    const SERVICE_ID = 'service_ig513hn';
    const TEMPLATE_ID = 'template_ijwmi5k';
    const PUBLIC_KEY = 'jvG1cxtDA6bhO2Dga';

    emailjs.send(SERVICE_ID, 'template_0zix8fo', formData, PUBLIC_KEY)
    .then((response) => {
      console.log('Message sent to owner!', response.status, response.text);
    })
    .catch((err) => {
      console.error('Failed to send to owner:', err);
    });

    emailjs.send(SERVICE_ID, TEMPLATE_ID, formData, PUBLIC_KEY)
      .then((response) => {
        Swal.fire({
          title: 'Success!',
          text: 'Your message has been sent successfully.',
          icon: 'success',
          confirmButtonText: 'Yayyy',
          confirmButtonColor: '#a855f7'
        });
        setFormData({ name: '', email: '', phone: '', message: '' }); // Clear form
      })
      .catch((error) => {
        Swal.fire({
          title: 'Oops!',
          text: 'Something went wrong. Please try again later.',
          icon: 'error',
          confirmButtonText: 'Oh no!',
          confirmButtonColor: '#ef4444'
        });
        console.error('FAILED...', error);
      });
  };

  return (
    <div className="contact-wrapper">
      <div className="contact-bg-layer"></div>
      
      <h2 className="contact-heading">Need Help? Contact Us Now!</h2>

      <div className="contact-section">
        <div className="form-area">
          <form className="contact-form-inside" onSubmit={handleSubmit}>
            <input 
              name="name" 
              placeholder="Full Name *" 
              value={formData.name} 
              onChange={handleChange} 
              required 
            />
            <input 
              name="email" 
              type="email" 
              placeholder="Email Address" 
              value={formData.email} 
              onChange={handleChange} 
              required 
            />
            <input 
              name="phone" 
              type="tel" 
              placeholder="Phone Number *" 
              value={formData.phone} 
              onChange={handleChange} 
              required 
            />
            <textarea 
              name="message" 
              rows="1" 
              placeholder="Tell us more about your query..." 
              value={formData.message} 
              onChange={handleChange} 
              required
            ></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div>

        <div className="info-wrapper">
          <p>Ready to bring your vision to life? Fill out the form and we'll get back to you within 24 hours to discuss your project.</p>
          <div className="info-details">
            <div className="info-row">
              <FaPhoneAlt className="icon" />
              <span>+91-8056064224</span>
            </div>
            <div className="info-row">
              <FaEnvelope className="icon" />
              <span>contact@tech4all.in</span>
            </div>
            {/* <div className="info-row">
              <FaMapMarkerAlt className="icon" />
              <span>931 Abia Martin Drive, PA, Pennsylvania - 18104</span>
            </div> */}
          </div>
        </div>
      </div>
      
      <ScrollToTopButton />
    </div>
  );
};

export default Contact;
